import * as React from "react";
import { Navigate, useParams } from "react-router-dom";
import {
  DeckWrapper,
  GameWrapper,
  ItemLabel,
  TimerWrapper,
} from "src/components/Game/Game.components";
import ControlledSwitch from "src/components/shared/Switch/ControlledSwitch";
import { displayErrorToast } from "src/components/shared/Toasts/Toast";
import Table from "src/components/Table";
import Timer from "src/components/Timer";
import UserDeck from "src/components/UserDeck";
import { ToastIds } from "src/enums/errorToastIds";
import { useGameContext } from "src/game/useGameContext";
import { CREATE_GAME_PATH, JOIN_GAME } from "src/utils/routesPaths";
import TaskListPanel from "src/components/TaskListPanel/TaskListPanel";
import VotesSummaryTable from "src/components/VotesSummaryTable";
import { UserRole } from "src/enums/user/userRoles";
interface RouteProps {
  gameId: string;
}

const Game: React.FunctionComponent = () => {
  const {
    gameState,
    actionHandlers: { updateUser },
  } = useGameContext();
  const { gameId } = useParams<keyof RouteProps>() as RouteProps;

  if (gameState.votingFinished === true && gameState.gameSummary) {
    return <Navigate to={CREATE_GAME_PATH} />;
  }

  if (!gameState.user) {
    return <Navigate to={`${JOIN_GAME}${gameId}`} />;
  }

  const toggleSpectatorMode = async () => {
    if (!gameState.token || !gameState.user) {
      return;
    }
    try {
      const response = await updateUser({
        gameId,
        token: gameState.token,
        user: {
          name: gameState.user?.name,
          isSpectator: !gameState.user.isSpectator,
        },
      });
      if (response.error) {
        displayErrorToast(
          `Failed to update user ${response.error.message}`,
          ToastIds.USER_UPDATE_FAILED
        );
      }
    } catch (e) {
      displayErrorToast("Failed to update user");
    }
  };

  const isDeckHidden =
    !gameState.game?.task ||
    (gameState.user?.role == UserRole.USER && !!gameState.voteReveal) ||
    (gameState.user.isSpectator && !gameState.voteReveal);

  return (
    <GameWrapper>
      <TimerWrapper>
        <Timer />
        <ControlledSwitch
          value={gameState.user.isSpectator}
          onChange={toggleSpectatorMode}
        />
        <ItemLabel>Spectator</ItemLabel>
      </TimerWrapper>
      <Table />
      <DeckWrapper>
        <VotesSummaryTable isDeckHidden={isDeckHidden} />
        <UserDeck isDeckHidden={isDeckHidden} />
      </DeckWrapper>
      <TaskListPanel />
    </GameWrapper>
  );
};

export default Game;
